import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'root-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BodyComponent {

  constructor() { }

}
